var _circle, _defs, _g, _image, _rect, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "300px",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-10 -10 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#fff",
    cx: 42.5,
    cy: 42.5,
    r: 52.5,
    opacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-3 {\n        fill: #57825f;\n      }\n\n      .cls-8 {\n        isolation: isolate;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 42.4,
    cy: 42.7,
    r: 33.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 28.9,
    y: 20.8,
    width: 29,
    height: 41.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.5,59.6c0,.2,0,.5-.3.6-.2.2-.4.3-.6.3h-6.3c-.2,0-.5,0-.6-.3-.2-.2-.3-.4-.3-.6v-1.8c0-.2,0-.5.3-.6.2-.2.4-.3.6-.3h6.3c.2,0,.5,0,.6.3.2.2.3.4.3.6v1.8ZM30.7,38.4c0-3,1.2-6,3.4-8.1,2.2-2.2,5.2-3.4,8.3-3.4,15.5.6,15.5,22.3,0,22.9-3.1,0-6.1-1.2-8.3-3.4-2.2-2.2-3.4-5.1-3.4-8.1h0ZM54.2,57.8h-5.9c0-.7-.3-1.4-.8-1.9-.5-.5-1.2-.8-1.9-.8h-2.3v-3.6c3.4-.2,6.6-1.7,9-4.2,2.3-2.4,3.6-5.7,3.6-9-.7-17.6-26.3-17.6-27,0,0,3.4,1.3,6.6,3.6,9,2.3,2.4,5.5,3.9,9,4.2v3.6h-2.3c-.7,0-1.4.3-1.9.8-.5.5-.8,1.2-.8,1.9h-5.9c-.3,0-.6.2-.8.4-.2.3-.2.6,0,.9.2.3.5.4.8.4h5.9c0,.7.3,1.4.8,1.9.5.5,1.2.8,1.9.8h6.3c.7,0,1.4-.3,1.9-.8.5-.5.8-1.2.8-1.9h5.9c.3,0,.6-.2.8-.4.2-.3.2-.6,0-.9-.2-.3-.4-.4-.8-.4h0ZM37.9,38.4c.2-5.8,8.8-5.8,9,0-.2,5.8-8.8,5.8-9,0ZM48.7,38.4c0-1.6-.7-3.2-1.8-4.4-1.2-1.2-2.8-1.8-4.5-1.8-8.3.3-8.3,12.1,0,12.4,1.7,0,3.3-.7,4.5-1.8,1.2-1.2,1.8-2.7,1.8-4.4h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.2,
    y: 12.2,
    width: 54,
    height: 63
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 7.9,
    y: 8.2,
    width: 69,
    height: 69
  }))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 56,
    height: 68,
    transform: "translate(15.2 7.2)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAABFCAYAAADw+E4/AAAACXBIWXMAAAsSAAALEgHS3X78AAADwklEQVRoge1b7Y4bMQj0Vvf+j9ztj9ZbHxmGGeyoUhWk0zn+AMZgYJ3sGB/60Ic+9KHzdL2L8X3fFu/ruu536bIN0gXTod0NaCloAqvmygC6YG2QAsBdy5ZAXLCyQhvgFBlIaQrEASqBLADGMWUuUzCOpXNVoCVIArAC57ptBa4N9otK1QBmbdb3IirMWz9PANcwgpSkgAnQAQ3FbbR/CyLWhEo0AbqAM3eM/6u+vwISoNRdI4/k/2yzcfRZpem66/8xgPve930hoC8gEytWVqtAMp5VpI0A7bOpWDKzSATouC9SslJeAoys+RUnECHZeYwAEWDEY+1TLdOybGXJyi0dkLGdKRbHsvQiu2wn8Mw2+hugHdeuPBwLrnxi8PnGK7osA8miqAsytqei6zwF8Donrkl5PCDDeazOEksfKshVqeiSCsmVkHomZzuzWBxX04hD6CxKHtBNIa7bIl6Z9aqAFHnEsboYGLkVMqXRGPqcKZ0BQNTJr+NHwTQjBHjtV61Z5VS2qTJVIB3BcX62CUwO84pKlxS4Y0lVCLMyU0ixTit4OcVAV1iWOmZ/PE9VMMrWRf4PqZZkoDr5NVvTTTN0XTfwtAX+C74nQMZi2i3POnIsfirI7jW9cuOGNmndLMTD0qdryUoIu4uh9zSFnJaXVCCzXc4+I3IrIUWXTD9IpywZgVfk1KyIp+WyCKR0/ecI+UOq1dC5jGOWHo4ld3aUVTgKeDvYrKSAPLKbIjnXIcjT4PoMZBVM0Jiy2+4TBAt0lX4PPSCFr8E6QqonFAZYlXPsTDKrdc9LF2Amr5VCOi6b9VWPYQpP2YuiV7p5MgvtVCjSw5C1TacL9HeQUhbqBXoRfJy08S7gLb5q7cpKLmVets6R19647vUHonvw+8/q6pABk70IeWPnTCpRTnliQDUqeqpR8jelHUtOi63t2Fetzzarm74guSBXEKug1RUz4dFds2KCuWjrXCogI7Bqjht8kOsefQBwLJkBYfen0ULIC9jZPAL4RHTNhP4c+MyitRnQOIbWldQBmSmszGeWXNtu3qX0AvK6rhv8CgTlQKRwJJY7WUphfTbtuiuKrrP/Grw4WNczF2VzJOoEHmadSbM/zsmCFHNdNA/Sid/WRWEMcJZ2mDVnG1lqK8Km+e/AT0GVS2Sn4ind9KQlY76M7sisxQoG5sIl2b93faTs/fa881Vby0WrS7hSkeZbBDvfUSpW/i5sF+QjRXvh5eQXsKWbHnubAEo/+4bPGEa07Lzls73z/+27WhmdAnz6Dbxfcofqdhi9+pYAAAAASUVORK5CYII="
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.2,
    y: 7.2,
    width: 56,
    height: 68
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 27.9,
    y: 19.8,
    width: 31,
    height: 43.4
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIp);
export default __webpack_public_path__ + "static/media/ip.f5c81d3de51045932dda5a7e68fc2854.svg";
export { ForwardRef as ReactComponent };